import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { take } from 'rxjs';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-change-password',
  imports: [
    ReactiveFormsModule,
    InputGroupModule,
    InputIconModule,
    IconFieldModule,
    InputGroupAddonModule,
    InputTextModule,
    ButtonModule,
    FloatLabelModule,
  ],
  templateUrl: './change-password.html',
  styleUrl: './change-password.css',
  standalone: true,
})
export class ChangePassword {
  private authService = inject(Auth);
  public dialogRef = inject(DynamicDialogRef);
  public messageService = inject(MessageService);
  currentPasswordVisible = false;
  newPasswordVisible = false;
  confirmNewPasswordVisible = false;

  form = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required]),
    confirmNewPassword: new FormControl('', [Validators.required]),
  });

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: $localize`Error`,
        detail: $localize`Please fill in all required fields.`,
      });
      return;
    }
    this.authService
      .changePassword(this.form.value.oldPassword!, this.form.value.newPassword!)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.dialogRef.close();
          this.messageService.add({
            severity: 'success',
            summary: $localize`Success`,
            detail: $localize`Password changed successfully`,
          });
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: $localize`Error`,
            detail: $localize`Invalid password`,
          });
        },
      });
  }

  toggleCurrentPasswordVisibility() {
    this.currentPasswordVisible = !this.currentPasswordVisible;
  }

  toggleNewPasswordVisibility() {
    this.newPasswordVisible = !this.newPasswordVisible;
  }

  toggleConfirmNewPasswordVisibility() {
    this.confirmNewPasswordVisible = !this.confirmNewPasswordVisible;
  }
}
